// For each view you need to create a function to add it to the state provider
function initCoreStates($stateProvider) {

    $stateProvider.state('home.samples', {
        url : "/samples",
        templateUrl : "views/common/samples.html",
        data : {
        	permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.auditList', {
        url : "/audit/list",
        templateUrl : "views/core/audit.list.html",
        data : {
            type : 'search',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.userCreate', {
        url : '/user/create',
        templateUrl : "views/core/user.detail.html",
        controller: "userDetailCreateCtrl",
        data : {
            type : 'create',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.userList', {
        url : "/user/list",
        templateUrl : "views/core/user.list.html",
        data : {
            type : 'search',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.userUpdate', {
        url : '/user/:id',
        templateUrl : "views/core/user.detail.html",
        controller: "userDetailUpdateCtrl",
        data : {
            type : 'update',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.parameterList', {
        url : '/parameter',
        templateUrl : "views/core/parameter.list.html",
        data : {
        	permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.parameterCreate', {
        url : '/parameter/create',
        templateUrl : "views/core/parameter.detail.html",
        data : {
            type : 'create',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.parameterUpdate', {
        url : '/parameter/:id',
        templateUrl : "views/core/parameter.detail.html",
        data : {
            type : 'update',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.userSign', {
        url : '/usersign',
        templateUrl : "views/core/user.sign.html",
        controller: "userSignCtrl",
        resolve:{
        	userSignDataResolve: function(userService){
        		return userService.getSignature();
        	}
        },
        data : {
            permissions : {
                only : ROLE_TYPE.codesExceptClient()
            }
        }
    });

}
